import { TitleCasePipe } from '@angular/common';

import { TEXT } from '../../../../../../helpers';
import { SentenceCasePipe } from '../../../../../../pipes/sentence-case-pipe';

const titleCasePipe: TitleCasePipe = new TitleCasePipe();
const sentenceCasePipe = new SentenceCasePipe();

export const text = {
	addToTender: titleCasePipe.transform(TEXT.addToTender),
	archive: titleCasePipe.transform(TEXT.archive),
	attachments: titleCasePipe.transform(TEXT.attachments),
	client: titleCasePipe.transform(TEXT.client),
	clientContact: TEXT.clientContact,
	contactEmail: titleCasePipe.transform(TEXT.contactEmail),
	contactPerson: titleCasePipe.transform(TEXT.contactPerson),
	createDocument: TEXT.createDocument,
	createdDocuments: titleCasePipe.transform(TEXT.createdDocuments),
	customDocument: TEXT.customDocument,
	documentTitle: titleCasePipe.transform(TEXT.documentTitle),
	deactivate: titleCasePipe.transform(TEXT.deactivate),
	download: titleCasePipe.transform(TEXT.download),
	downloadAllAttachments: TEXT.downloadAllAttachments,
	downloadAllFiles: TEXT.downloadAllFiles,
	downloadExpiryWarning: sentenceCasePipe.transform(TEXT.downloadExpiryWarning),
	downloadFiles: titleCasePipe.transform(TEXT.downloadFiles),
	dropdownPlaceholder: titleCasePipe.transform(TEXT.select),
	emailDocument: titleCasePipe.transform(TEXT.emailDocument),
	environment: TEXT.environment,
	exportAll: TEXT.exportAll,
	exportAllDocuments: TEXT.exportAllDocuments,
	exportDocuments: TEXT.exportDocuments,
	filterByDivision: TEXT.filterByDivision,
	generate: TEXT.generate,
	generatedDocuments: TEXT.generatedDocuments,
	generateAndDownload: TEXT.generateAndDownload,
	groupByDivision: TEXT.groupByDivision,
	inputPlaceholder: sentenceCasePipe.transform(TEXT.typeHere),
	labelSuffix: TEXT.labelSuffix,
	latestVersion: TEXT.latestVersion,
	noData: TEXT.noData,
	previewAndSend: TEXT.previewAndSend,
	productFolder: TEXT.productFolder,
	quoteDepth: TEXT.quoteDepth,
	section: TEXT.section,
	selectPlaceholder: TEXT.selectPlaceholder,
	sendApproval: TEXT.sendApproval,
	sendForSignature: TEXT.sendForSignature,
	subLocation1: TEXT.subLocation1,
	subLocation2: TEXT.subLocation2,
	subLocation3: TEXT.subLocation3,
	submit: TEXT.submit,
	superseded: TEXT.superseded,
	supersededVersions: TEXT.supersededVersions,
	splitByDivision: TEXT.splitByDivision,
	title: TEXT.title,
	uploadCustomDoc: TEXT.uploadCustomDoc,
	variation: TEXT.variation,
	versions: titleCasePipe.transform(TEXT.versions),
	viewAttachments: TEXT.viewAttachments,
	youCanFindFiles: TEXT.youCanFindFiles,
};
